<template>
  <div class="pill" :class="{'isActive': isActive}">
    <div class="pill-indicator"></div>
    <div class="pill-on-text">{{ isActiveLabel }}</div>
    <div class="pill-off-text">{{ isNotActiveLabel }}</div>
  </div>
</template>

<script>
export default {
  name: 'Pill',
  props: {
    isActive: false,
    isActiveLabel: {
      type: String,
      default: 'Yes'
    },
    isNotActiveLabel: {
      type: String,
      default: 'No'
    }
  }
}
</script>

<style lang="scss" scoped>
  .pill {
    width: 87px;
    height: 38px;
    background-color: #444;
    border-radius: 19px;
    overflow: hidden;
    position: relative;
    padding: 10px;
    color: #333;

    &.isActive {
    background-color: #21CE99;
    color: #fff;
    }

    &-indicator {
      width: 24px;
      height: 24px;
      background-color: #fff;
      border-radius: 50%;
      position: absolute;
      z-index: 5;
      top: 50%;
      transform: translateY(-50%);
      left: 7px;
      transition: transform 300ms ease;
      
      .pill.isActive & {
        transform: translate(50px, -50%);
        
      }
    }
    &-on-text,
    &-off-text {
      font-family: 'Roboto Medium';
      font-size: 15px;
      color: #FFFFFF;
      letter-spacing: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    &-on-text {
      left: 14px;
      opacity: 0;
      .pill.isActive & {
        opacity: 1;
      }
    }
    &-off-text {
      right: 14px;
      .pill.isActive & {
        opacity: 0;
      }
    }
}


</style>


// WEBPACK FOOTER //
// src/js/components/Pill.vue